import type { EstimatedScalingWidthDict } from "./ribbonBottomBarScalingTypes";

export let estimatedScalingWidths: EstimatedScalingWidthDict = {};

export const setEstimatedScalingWidths = (
  estimatedWidths: EstimatedScalingWidthDict
) => {
  estimatedScalingWidths = estimatedWidths;
};
